<script setup lang="ts">
import { computed } from 'vue';
import ProgressSpinner from 'primevue/progressspinner';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { useGetFetchContract } from 'src/api/queries/order-portal-bff';

const props = defineProps<{ contractId: string }>();

const { data: contract, isLoading } = useGetFetchContract(
  computed(() => props.contractId)
);

const actionItems = computed(() => contract.value?.action_items ?? []);
</script>

<template>
  <div class="px-4 py-2">
    <div v-if="isLoading" class="flex items-center">
      <ProgressSpinner style="width: 2rem; height: 2rem" />
    </div>

    <template v-else-if="contract">
      <div class="grid grid-cols-[auto_1fr_auto_1fr] gap-x-4 gap-y-1 text-sm mb-2">
        <span class="font-medium text-muted-color">Ref. Number</span>
        <span>{{ contract.reference_number ?? '--' }}</span>
        <span class="font-medium text-muted-color">Customer</span>
        <span>{{ contract.customer?.name ?? '--' }}</span>
        <span class="font-medium text-muted-color">Supplier</span>
        <span>{{ contract.supplier?.name ?? '--' }}</span>
        <span class="font-medium text-muted-color">Price/hour</span>
        <span>{{ contract.price_per_hour != null ? `&euro; ${contract.price_per_hour}` : '--' }}</span>
        <span class="font-medium text-muted-color">Max hours</span>
        <span>{{ contract.max_number_of_hours ?? '--' }}</span>
        <span class="font-medium text-muted-color">Annual adj.</span>
        <span>{{ contract.annual_price_adjustment ? 'Yes' : 'No' }}</span>
        <span class="font-medium text-muted-color">Description</span>
        <span class="col-span-3">{{ contract.description ?? '--' }}</span>
      </div>

      <template v-if="actionItems.length > 0">
        <p class="text-sm font-medium text-muted-color mb-1">Action Items</p>
        <DataTable :value="actionItems" dataKey="id" size="small">
          <Column field="recipe_name" header="Recipe" />
          <Column field="recipe_type" header="Type" />
          <Column field="interval_in_months" header="Interval (months)" />
          <Column header="Price">
            <template #body="{ data }">
              {{ data.price != null ? `&euro; ${data.price}` : '--' }}
            </template>
          </Column>
        </DataTable>
      </template>
    </template>
  </div>
</template>
